<template>
  <div>
    <pm-navbar />

    <div class="main">
      <slot />
    </div>

  </div>
</template>

<script>
import PmNavbar from "~/components/layout/PmNavbar"

export default {
  name: 'Default',
  components: {
    PmNavbar
  }
}
</script>